import axios from "axios";
import qs from "qs";
import authServices from "../../../../../services/authServices";
import dataProvider from "../../../../../services/dataProvider";
import icomplyLogo from "../../../../../assets/images/icomply.png";
import "./inline-form-pdf-template.css" ;

function cleanupData(data,schema) {
    let cleanDataList = [];
    data.forEach((row) => {
        let cleanRow = {};
        Object.keys(schema).forEach((field) => {
            cleanRow[field] = row[field];
        });
        cleanRow.id = row.id;
        cleanDataList.push(cleanRow);
    });

    return cleanDataList;
}

export default function InlineFormToPDF(schema, formType, formTitle){

    // console.log(schema, formType, formTitle);

    var data = qs.stringify({
        formType,
        isInline: true,
    });

    var config = {
        method: "post",
        url: dataProvider.baseUrl + "inlineForms-getInlineFormsByFormType",
        headers: {
            orgid: authServices.getOrgId(),
            token: authServices.getToken(),
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: data,
    };

    return new Promise((resolve)=>{
        axios(config)
            .then(async (response) => {
                if (response.data.status === "success") {
                    let cleanData = cleanupData(response.data.data,schema);
                    // console.log(schema);
                    let fileKeys = [] ; 
                    Object.keys(schema).forEach(key => {
                        if(schema[key].type === "file") {
                            fileKeys.push(key);
                        }
                    })
                    if(fileKeys.length > 0) {
                        // console.log("fk",fileKeys);
                        for(let key of fileKeys){
                            // console.log("KEY",key)
                            let filePathList = cleanData.map(data => data[key]);
                            let links = await getFilePath(filePathList) ;
                            // console.log("Links",links);
                            if(links !== "ERROR") {
                                cleanData = cleanData.map((data) => ({...data,[key] : links[data[key]] }))
                            }
                            // console.log("CK",cleanData);
                        };

                    }
                    let r = await getInlinePDF(schema,cleanData,formTitle)
                    resolve(r);
                } else {
                    console.error("ERROR");
                    resolve("");
                }
            })
            .catch((err) => {
                console.error(err);
                resolve("");
            });
    })
};

async function getInlinePDF(schema,data,formTitle){
    // console.log(schema,data,formTitle);
    let html = `<style>
        .template-container {
            background-color: #fff ;
            margin : 1rem ;
            padding: 1rem ;
            font-family: sans-serif ;
            border-radius: 8px ;
            border : 1px solid #eee ;
        }

        .template-icomply-brand {
            display:flex;
            align-items:center;
            justify-content:center;
            padding: 2rem 0;
        }

        .template-icomply-brand img {
            height : 3rem ;
        }

        .template-container .template-name {
            font-size: 1.25rem ;
            font-weight: 700 ;
            line-height:2;
        }

        .template-table {
            appearance: none ;
            width: 100% ;
            table-layout: fixed ;
            border-collapse: collapse ;
        }

        .template-table td,
        .template-table th {
            border: 1px solid #888 ;
            padding: 0.25rem ;
            text-align: center ;
            word-break: break-all ;
        }

        .template-table th {
            background-color: #eee ;
            text-align: center ;
        }
    </style>
    
    ` ;

    html += `
    <div class="template-container">
        <div class="template-icomply-brand">
            <img src="${icomplyLogo}" />
        </div>
        <div class="template-name">${formTitle}</div>
        <table class="template-table">
            <thead>
                <tr>
                    ${ Object.keys(schema).map((f) => `<th>${schema[f].name}</th>`).join("") }
                </tr>
            </thead>
            <tbody>
                ${ data.map((row) => `<tr>${
                    Object.keys(schema).map((f) => {
                        if(schema[f].type === "file") {
                            return `<td><a href="${row[f]}" target="_blank">View File</a></td>` ;
                        } else {
                            return `<td>${row[f]}</td>` ;
                        }
                    }).join("")
                }</tr>`).join("")}
            </tbody>
        </table>
    </div>
    `

    return html ;
}



async function getFilePath(filePathList) {
    // console.log("FPL",filePathList);
    return new Promise((res) => {
        var data = qs.stringify({
            filePathList : JSON.stringify(filePathList)
        });
        // console.log(data);
        var config = {
            method: "post",
            url: dataProvider.baseUrl + "getMultipleFilePathLinks",
            headers: {
                token: authServices.getToken(),
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                // console.log("RES",response);
                if(Object.keys(response.data).length > 0) {
                    res(response.data);
                } else {
                    res("ERROR");
                }
            })
            .catch(function (error) {
                console.error(error);
                res("ERROR");
            });
    });
}